"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.magicBlock = void 0;
const gsap_1 = require("gsap");
const gsap_utils_1 = require("../gsap-utils");
const createMagicBlock = (target) => {
    var _a, _b, _c;
    const newTarget = (_b = ((target === null || target === void 0 ? void 0 : target.querySelector) ? (_a = target === null || target === void 0 ? void 0 : target.querySelector) === null || _a === void 0 ? void 0 : _a.call(target, '.text') : target)) !== null && _b !== void 0 ? _b : target;
    let color;
    const text = newTarget.querySelector('.text');
    const tspan = newTarget.querySelector('tspan[fill]');
    if (text) {
        color = text.getAttribute('fill');
    }
    else if (tspan) {
        color = tspan.getAttribute('fill');
    }
    else {
        color = newTarget.getAttribute('fill');
    }
    const box = (_c = (0, gsap_utils_1.getBBox)(newTarget)) !== null && _c !== void 0 ? _c : newTarget.getBoundingClientRect();
    if (box) {
        const magicBlock = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        magicBlock.setAttribute('x', box.x.toString());
        magicBlock.setAttribute('y', box.y.toString());
        magicBlock.setAttribute('width', box.width.toString());
        magicBlock.setAttribute('height', box.height.toString());
        magicBlock.setAttribute('fill', color !== null && color !== void 0 ? color : 'black');
        magicBlock.setAttribute('opacity', '1');
        magicBlock.setAttribute('fill-opacity', '1');
        return magicBlock;
    }
    return undefined;
};
const magicBlock = (target) => {
    const magicBlock = createMagicBlock(target);
    const parent = target.parentElement;
    if (parent && magicBlock) {
        parent.appendChild(magicBlock);
        const magicBlockTimeline = gsap_1.gsap
            .timeline()
            .fromTo(magicBlock, {
            duration: 0,
            transformOrigin: 'left center',
            transformBox: 'fill-box',
            transform: 'scaleX(0)',
        }, {
            duration: 0.45,
            transformOrigin: 'left center',
            transform: 'scaleX(1)',
        })
            .to(magicBlock, {
            duration: 0.55,
            opacity: 0,
            transformOrigin: 'right center',
            transform: 'scaleX(0)',
        });
        const textTimeline = gsap_1.gsap
            .timeline()
            .from(target, { opacity: 0, delay: 0.25, duration: 0.5 })
            .to(target, { opacity: 1, delay: 0.95, duration: 0.05 });
        return gsap_1.gsap.timeline().add(magicBlockTimeline).add(textTimeline, '<');
    }
    return gsap_1.gsap.timeline();
};
exports.magicBlock = magicBlock;
//# sourceMappingURL=magic-block.js.map